window.MAKE_MODEL_MAP = {
  "Acura": [
    "CL","ILX","Integra","Integra Type S","Legend","MDX",
    "NSX","RDX","RL","RLX","RSX (Integra)","TL","TLX"
  ],
  "Alfa Romeo": [
    "4C","Brera","Giulia","Spider","Stelvio","Tonale"
  ],
  "Audi": [
    "A1","A3","A4","A5","A6","A7","A8","Q2","Q3","Q5","Q7","Q8",
    "RS3","RS4","RS5","RS6","RS7","S3","S4","S5","S6","S7","S8",
    "TT","TTS","TT RS"
  ],
  "BMW": [
    "128i","135i","228i","230i","320i","328i","330i","335i","340i",
    "428i","430i","435i","440i","528i","530i","535i","540i","550i",
    "M135i","M235i","M240i","M2","M3","M4","M5","M6",
    "X1","X2","X3","X4","X5","X6","X7","Z4"
  ],
  "Chevrolet": [
    "Camaro","Corvette","Cruze","Malibu","Silverado","SS"
  ],
  "Ford": [
    "Bronco","Focus","Focus RS","Mustang","Mustang Mach-E"
  ],
  "Honda": [
    "Accord","Civic","Civic Si","Civic Type R","CR-Z","Fit",
    "Integra","Prelude","S2000"
  ],
  "Hyundai": [
    "Elantra N","Genesis Coupe","i30 N","Kona N","Veloster N"
  ],
  "Infiniti": [
    "G35","G37","Q50","Q60","QX50"
  ],
  "Lexus": [
    "GS","IS","IS F","LC","LS","NX","RC","RC F","RX"
  ],
  "Mazda": [
    "3","6","CX-3","CX-5","CX-50","CX-9","Miata"
  ],
  "Mercedes-Benz": [
    "A-Class","AMG GT","C-Class","CLA","CLS","E-Class",
    "G-Class","GLA","GLC","GLE","S-Class","SL"
  ],
  "Mini": [
    "Cooper","Cooper S","JCW"
  ],
  "Nissan": [
    "350Z","370Z","Altima","GT-R","Sentra","Silvia"
  ],
  "Porsche": [
    "718 Cayman","718 Boxster","911","Cayenne","Macan","Panamera"
  ],
  "Subaru": [
    "BRZ","Forester","Impreza","Legacy","STI","WRX"
  ],
  "Toyota": [
    "86","Camry","Celica","Corolla","GR Corolla","GR86",
    "MR2","Supra","Tacoma"
  ],
  "Volkswagen": [
    "Corrado","GLI","GTI","Golf","Golf R","ID.4","ID.Buzz",
    "Jetta","Passat","Polo GTI","R32","Scirocco",
    "Tiguan","Touareg","Up! GTI"
  ],
  "Volvo": [
    "C30","S60","S90","V60","V90","XC40","XC60","XC90"
  ]
};
